import React from 'react';
import Hero from '../components/Hero';
import { useLanguage } from '../contexts/LanguageContext';
import { FaMicroscope, FaChartBar, FaHandshake, FaShieldAlt, FaGlobe } from 'react-icons/fa';

const Servicos = () => {
  const { t } = useLanguage();

  const areasConsultoria = t('services.consulting.areas.items');

  const servicosAdicionais = t('services.consulting.additional.items');

  const areasPesquisa = t('services.research.areas.items');

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <Hero
        title={t('services.hero.title')}
        subtitle={t('services.hero.subtitle')}
        description={t('services.hero.description')}
        showButtons={false}
      />

      {/* Conexão */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4 mb-12 text-center">
              <div className="inline-flex items-center px-4 py-2 bg-emerald-100 rounded-full">
                <span className="text-emerald-600 text-sm font-medium">// {t('services.connection.badge').replace('// ', '')}</span>
              </div>

              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
                <span className="block">{t('services.connection.title')}</span>
                <span className="block bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
                  {t('services.connection.titleHighlight')}
                </span>
              </h2>
            </div>

            <div className="space-y-8 text-gray-600 leading-relaxed text-lg text-justify">
              <p>
                {t('services.connection.paragraphs.0')}
              </p>

              <p>
                {t('services.connection.paragraphs.1')}
              </p>

              <p>
                {t('services.connection.paragraphs.2')}
              </p>

              <div className="bg-gradient-to-r from-emerald-50 to-teal-50 border-l-4 border-emerald-500 p-8 rounded-r-lg text-left">
                <div className="flex items-start space-x-4">
                  <div className="text-4xl">🌉</div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">{t('services.connection.mission.title')}</h3>
                    <p className="text-gray-700">
                      {t('services.connection.mission.description')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Consultoria */}
      <section className="py-20 bg-gradient-to-br from-slate-50 to-emerald-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4 mb-12 text-center">
              <div className="inline-flex items-center px-4 py-2 bg-emerald-100 rounded-full">
                <span className="text-emerald-600 text-sm font-medium">// {t('services.consulting.badge').replace('// ', '')}</span>
              </div>

              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
                <span className="block">{t('services.consulting.title')}</span>
                <span className="block bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
                  {t('services.consulting.titleHighlight')}
                </span>
              </h2>
            </div>

            <div className="space-y-8 text-gray-600 leading-relaxed text-lg text-justify">
              <p>
                {t('services.consulting.paragraphs.0')}
              </p>

              <p>
                {t('services.consulting.paragraphs.1')}
              </p>

              {/* Áreas de Atuação */}
              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                  <span className="text-3xl mr-3">🎯</span>
                  {t('services.consulting.areas.title')}
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {(areasConsultoria || []).map((area, index) => (
                    <div key={index} className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-emerald-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span className="text-gray-700">{area}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Serviços Adicionais */}
              <div className="bg-gradient-to-r from-emerald-600 to-teal-600 rounded-2xl p-8 text-white">
                <h3 className="text-2xl font-bold mb-6 flex items-center">
                  <span className="text-3xl mr-3">⚡</span>
                  {t('services.consulting.additional.title')}
                </h3>
                <div className="space-y-4">
                  {(servicosAdicionais || []).map((servico, index) => (
                    <div key={index} className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-white rounded-full mt-2 flex-shrink-0"></div>
                      <span className="text-emerald-100">{servico}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-gradient-to-r from-emerald-50 to-teal-50 border-l-4 border-emerald-500 p-8 rounded-r-lg text-left">
                <p className="font-medium text-gray-800 text-xl">
                  {t('services.consulting.commitment')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Estudos e Pesquisas */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4 mb-12 text-center">
              <div className="inline-flex items-center px-4 py-2 bg-emerald-100 rounded-full">
                <span className="text-emerald-600 text-sm font-medium">// {t('services.research.badge').replace('// ', '')}</span>
              </div>

              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
                <span className="block">{t('services.research.title')}</span>
                <span className="block bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
                  {t('services.research.titleHighlight')}
                </span>
              </h2>
            </div>

            <div className="space-y-8 text-gray-600 leading-relaxed text-lg text-justify">
              <p>
                {t('services.research.paragraphs.0')}
              </p>

              <p>
                {t('services.research.paragraphs.1')}
              </p>

              <p>
                {t('services.research.paragraphs.2')}
              </p>

              {/* Áreas de Destaque */}
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                  <FaMicroscope className="text-3xl mr-3 text-emerald-600" />
                  {t('services.research.areas.title')}
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {(areasPesquisa || []).map((area, index) => (
                    <div key={index} className="flex items-start space-x-3 p-4 bg-gray-50 rounded-lg">
                      <div className="w-2 h-2 bg-emerald-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span className="text-gray-700">{area}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-gradient-to-r from-emerald-50 to-teal-50 border-l-4 border-emerald-500 p-8 rounded-r-lg text-left">
                <div className="flex items-start space-x-4">
                  <FaChartBar className="text-4xl text-emerald-600" />
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">{t('services.research.rigor.title')}</h3>
                    <p className="text-gray-700">
                      {t('services.research.rigor.description')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Resumo dos Serviços */}
      <section className="py-20 bg-gradient-to-br from-slate-50 to-emerald-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-4 py-2 bg-emerald-100 rounded-full mb-6">
              <span className="text-emerald-600 text-sm font-medium">// {t('services.differential.badge').replace('// ', '')}</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              {t('services.differential.title')}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {t('services.differential.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
              <div className="w-16 h-16 bg-gradient-to-r from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center mb-6">
                <FaMicroscope className="text-2xl text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{t('services.differential.items.0.title')}</h3>
              <p className="text-gray-600 leading-relaxed">
                {t('services.differential.items.0.description')}
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
              <div className="w-16 h-16 bg-gradient-to-r from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center mb-6">
                <FaGlobe className="text-2xl text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{t('services.differential.items.1.title')}</h3>
              <p className="text-gray-600 leading-relaxed">
                {t('services.differential.items.1.description')}
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
              <div className="w-16 h-16 bg-gradient-to-r from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center mb-6">
                <FaHandshake className="text-2xl text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{t('services.differential.items.2.title')}</h3>
              <p className="text-gray-600 leading-relaxed">
                {t('services.differential.items.2.description')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-br from-slate-900 via-teal-900 to-emerald-900 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 w-96 h-96 bg-emerald-400 rounded-full mix-blend-multiply filter blur-xl animate-pulse"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-teal-400 rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-1000"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            {t('services.cta.title')}
          </h2>
          <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto">
            {t('services.cta.description')}
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <a
              href="/contato"
              className="group bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-8 py-4 rounded-xl font-semibold hover:from-emerald-600 hover:to-teal-700 transition-all duration-300 shadow-2xl hover:shadow-emerald-500/25 flex items-center justify-center space-x-2"
            >
              <span>{t('services.cta.buttons.consulting')}</span>
              <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </a>
            <a
              href="/contato"
              className="group border-2 border-white/30 text-white px-8 py-4 rounded-xl font-semibold hover:bg-white hover:text-slate-900 transition-all duration-300 backdrop-blur-sm flex items-center justify-center space-x-2"
            >
              <span>{t('services.cta.buttons.research')}</span>
              <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Servicos;